import { EmptyContent } from "../EmptyContent";
import { Select } from "antd";
import React, { useEffect, useGlobal } from "react";

const { Option } = Select;

export const DistrictFilter = ({ setDistrict, districts = [] }) => {
	useEffect(() => {
		return () => setDistrict(null);
	}, []);

	return (
		<Select
			showSearch
			style={{ width: 300 }}
			placeholder="Seleccione una comuna"
			optionFilterProp="children"
			onSelect={setDistrict}
			filterOption={(input, option) =>
				option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
			}
			notFoundContent={
				<EmptyContent description="Sin información disponible..."></EmptyContent>
			}
		>
			{[].concat(districts).map((district, i) => (
				<Option key={i} value={district}>
					{district}
				</Option>
			))}
		</Select>
	);
};
